export const rankToStar = (rank: 1 | 2 | 3 | 4 | 5): string => {
  switch (rank) {
    case 1:
      return '★☆☆☆☆';
    case 2:
      return '★★☆☆☆';
    case 3:
      return '★★★☆☆';
    case 4:
      return '★★★★☆';
    case 5:
      return '★★★★★';
  }
};
